import Link from 'next/link';
import { IPublicationWithImage } from '../utils';
import * as S from './style';

export const PublicationsGrid = ({
    publications,
    title,
}: {
    publications: IPublicationWithImage[];
    title: string;
}) => {
    return (
        <S.PublicationsSection>
            <S.Title>Other Publications Featuring {title.split(' ')[0]}</S.Title>
            <S.Grid>
                {publications.map((pub, index) => (
                    <S.Card key={index}>
                        <S.LogoWrapper>
                            <S.LogoImage src={pub.image} alt={pub.title} />
                        </S.LogoWrapper>
                        <S.Content>
                            <S.PublicationTitle>{pub.title}</S.PublicationTitle>
                            <Link href={pub.link} passHref>
                                <S.LearnMore>Learn more</S.LearnMore>
                            </Link>
                        </S.Content>
                    </S.Card>
                ))}
            </S.Grid>
        </S.PublicationsSection>
    );
};
